// @flow
import { createContext } from 'react';
import type { Context } from 'react';

export const LDContext: Context<{
  experiments: Array<Object>,
}> = createContext({
  experiments: [],
});
